/**
 * Tohumlu sözde-rastgele üreteç (mulberry32).
 * Savaşın yeniden üretilebilir olması için Math.random ASLA kullanılmaz.
 */
export class Rastgele {
  #durum: number

  constructor(tohum: number) {
    // 0 tohumu dejenere diziye yol açar; sabit bir altın oran kaydırması uygulanır.
    this.#durum = (tohum >>> 0) || 0x9e3779b9
  }

  /** [0, 1) aralığında bir ondalık döner. */
  sonraki(): number {
    this.#durum = (this.#durum + 0x6d2b79f5) >>> 0
    let t = this.#durum
    t = Math.imul(t ^ (t >>> 15), t | 1)
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }

  /** Sınırlar dahil tamsayı döner. */
  tamsayi(altSinir: number, ustSinir: number): number {
    return altSinir + Math.floor(this.sonraki() * (ustSinir - altSinir + 1))
  }

  /** oran ∈ [0,1] olasılıkla true döner. */
  sans(oran: number): boolean {
    if (oran <= 0) return false
    if (oran >= 1) return true
    return this.sonraki() < oran
  }
}
